import React from "react";
import { Checkbox } from "@/race-tracker/components/ui/checkbox";
import {
  SERPER_FIELD_ORDER,
  SERPER_FIELD_LABELS,
  normalizeSerperQueryFields,
  SERPER_MAX_SELECTED_FIELDS,
} from "@/race-tracker/lib/serperQueryCatalog";

/** Controlled multi-select for Serper query columns (same rules as Setup / run-sweep). */
export function SerperColumnFieldGrid({ fields, onFieldsChange }) {
  const list = normalizeSerperQueryFields(fields);

  const toggle = (field) => {
    const cur = new Set(normalizeSerperQueryFields(list));
    if (cur.has(field)) {
      if (cur.size <= 1) return;
      cur.delete(field);
    } else {
      if (cur.size >= SERPER_MAX_SELECTED_FIELDS) return;
      cur.add(field);
    }
    onFieldsChange(SERPER_FIELD_ORDER.filter((f) => cur.has(f)));
  };

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-3 gap-y-2">
      {SERPER_FIELD_ORDER.map((field) => {
        const checked = list.includes(field);
        const disableUncheck = list.length === 1 && checked;
        return (
          <label key={field} className="flex items-center gap-2 text-xs cursor-pointer select-none">
            <Checkbox checked={checked} disabled={disableUncheck} onCheckedChange={() => toggle(field)} />
            <span>{SERPER_FIELD_LABELS[field]}</span>
          </label>
        );
      })}
    </div>
  );
}
